import BusinessCardImg from 'assets/images/landing/Card.png'
import { motion } from 'framer-motion'
import {
  cardExitAnimation,
  cardInitAnimation,
  stepsAnimationVariants,
  stepsExitAnimation,
  stepsInitAnimation
} from 'utils/constants'

const CardAnimationItem = () => {
  return (
    <motion.div
      style={{
        background: 'rgba(255, 255, 255, 0.32)'
      }}
      className='h-[170px] border lg:h-[201px] w-[334px] rounded-[32px] overflow-hidden'
      initial={stepsInitAnimation}
      variants={stepsAnimationVariants}
      exit={stepsExitAnimation}
      animate='popIn'
    >
      <motion.img
        variants={{
          cardPopIn: {
            y: 40,
            transition: {
              bounceDamping: 0,
              duration: 2,
              delay: 1
            }
          }
        }}
        animate='cardPopIn'
        initial={cardInitAnimation}
        exit={cardExitAnimation}
        className='mx-auto'
        src={BusinessCardImg}
      />
    </motion.div>
  )
}

export default CardAnimationItem
